import { useQuery } from 'react-query'
import { AuthorizerServices } from '../../services/AuthorizerServices/AuthorizerServices'

export const useGetAuthorizationData = (authorizerId?: number | null) => {
  const { data, isLoading } = useQuery({
    queryKey: ['getAuthorizationData', authorizerId],
    enabled: !!authorizerId,
    queryFn: () => AuthorizerServices.getAuthorizationData(authorizerId),
  })

  return {
    authorizationData: data,
    isGettingAuthorizationData: isLoading,
  }
}
